export default __webpack_public_path__ + "static/media/Champion_Ahri_HP.1fe5df5f.png";